var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "funko-body"
  }, [!_vm.showCheckout ? _c('Navbar') : _vm._e(), _c('main', [_c('router-view')], 1), !_vm.showCheckout ? _c('Footer') : _vm._e(), !_vm.showCheckout ? _c('ShopCart') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }